import { useStore } from '@web/store'
import { User } from '@web/store/types/modules/user'
import { redirectToReturnUrl } from '@web/common/returnUrl'
import { useRouter } from 'vue-router'

import { useOnboardingResolver } from '@web/platform.v3/onboardings/useOnboardingResolver'

export function useRedirectAfterLogin () {
  const router = useRouter()
  const store = useStore()
  const { goAfterLogin } = useOnboardingResolver()

  async function redirectAfterLogin (user?: User): Promise<void> {
    if (user && (user.requirePhoneValidate || user.requiredUpdateProfile)) {
      goAfterLogin()
      return
    }

    const returnUrlFromQuery = router.currentRoute.value.query.returnUrl as string | null
    const returnUrlFromStore: string = store.state.main.returnUrl

    // Внешний returnUrl — только на домен платформы: к нему дописывается JWT.
    // Чужой адрес отклоняется, и пользователь уходит по обычному сценарию.
    if (redirectToReturnUrl(returnUrlFromQuery)) {
      return
    }
    if (/^https?:\/\//.test(returnUrlFromStore)) {
      if (!redirectToReturnUrl(returnUrlFromStore)) {
        goAfterLogin()
      }
    } else if (returnUrlFromStore && returnUrlFromStore !== '/') {
      router.push(returnUrlFromStore)
    } else {
      goAfterLogin()
    }
  }

  return { redirectAfterLogin }
}

export default useRedirectAfterLogin
